module.exports = __webpack_public_path__ + "img/ic_close_arrow.6ed6f081.svg";